import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9e040c04"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alipay-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const _hoisted_3 = {
  class: "flex-list",
  style: {
    "justify-content": "flex-start"
  }
};
const _hoisted_4 = {
  class: "notice-text"
};
const _hoisted_5 = {
  class: "notice-desc"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://ewe8txd9jt.feishu.cn/sheets/shtcnFl01iQTMCceH3uiGv3mEVc?sheet=f6CglY"
}, " 《域名隔离表》 ", -1));
const __default__ = {
  name: 'AliWebPayBaseConfig'
};
import SvgIcon from '@/components/SvgIcon.vue';
import { copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm', 'setVisible'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const alipayWebRef = ref(null); // 支付宝网站支付ref
    const alipayWebForm = reactive({
      appId: '',
      mchId: null,
      publicKey: '',
      appPrivateKey: '',
      appGateway: 'https://pay.wedobest.com.cn:8449/PayServer/pay/callbackAliPay',
      mchName: '',
      pkg: '',
      channelRate: 0.01
    }); // 支付宝网站支付
    const channelRateList = ref([]); // 费率列表
    const validateForm = () => {
      var _alipayWebRef$value;
      (_alipayWebRef$value = alipayWebRef.value) === null || _alipayWebRef$value === void 0 || _alipayWebRef$value.validate().then(() => {
        emit('submitForm', alipayWebForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        alipayWebForm.pkg = n.pkg;
        alipayWebForm.appId = n.appId;
        alipayWebForm.mchName = n.mchName;
        alipayWebForm.publicKey = n.publicKey;
        alipayWebForm.appPrivateKey = n.appPrivateKey;
        alipayWebForm.appGateway = n.appGateway;
        alipayWebForm.channelRate = n.channelRate;
        channelRateList.value = n.channelRateList;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: alipayWebForm,
        ref_key: "alipayWebRef",
        ref: alipayWebRef,
        rules: __props.rules,
        name: "alipayWeb-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: alipayWebForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => alipayWebForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "AppID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: alipayWebForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => alipayWebForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "mchName",
          label: "商户主体："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: alipayWebForm.mchName,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => alipayWebForm.mchName = $event),
            disabled: "",
            maxlength: 200
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "channelRate",
          label: "费率："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: alipayWebForm.channelRate,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => alipayWebForm.channelRate = $event),
            options: channelRateList.value
          }, null, 8, ["value", "options"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createTextVNode("使用支付宝支付功能将收取1%手续费")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "questionMark",
              "class-name": "question-icon"
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "publicKey",
          label: "支付宝公钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: alipayWebForm.publicKey,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => alipayWebForm.publicKey = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appPrivateKey",
          label: "应用私钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: alipayWebForm.appPrivateKey,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => alipayWebForm.appPrivateKey = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appGateway",
          label: "应用网关："
        }, {
          default: _withCtx(() => {
            var _alipayWebForm$appGat, _alipayWebForm$appGat2;
            return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(" https:// "), _createElementVNode("span", null, _toDisplayString((_alipayWebForm$appGat = alipayWebForm.appGateway) === null || _alipayWebForm$appGat === void 0 || (_alipayWebForm$appGat = _alipayWebForm$appGat.split('https://')[1]) === null || _alipayWebForm$appGat === void 0 ? void 0 : _alipayWebForm$appGat.split('/PayServer')[0]), 1), _createTextVNode(" " + _toDisplayString('/PayServer' + ((_alipayWebForm$appGat2 = alipayWebForm.appGateway) === null || _alipayWebForm$appGat2 === void 0 ? void 0 : _alipayWebForm$appGat2.split('PayServer')[1])), 1)]), _createVNode(_component_a_tooltip, null, {
              title: _withCtx(() => [_createTextVNode("复制")]),
              default: _withCtx(() => [_createVNode(SvgIcon, {
                "icon-class": "copy",
                "class-name": "copy-icon",
                onClick: _cache[6] || (_cache[6] = $event => _unref(copy)(alipayWebForm.appGateway))
              })]),
              _: 1
            })]), _createElementVNode("div", _hoisted_5, [_createTextVNode(" 请复制该链接，按 "), _hoisted_6, _createTextVNode(" 中 pay 业务名对应的域名，替换链接标红部分；并配置到支付宝开放平台-开发设置-应用网关处; "), _createVNode(_component_a_button, {
              class: "img-btn",
              type: "link",
              onClick: _cache[7] || (_cache[7] = $event => emit('setVisible', true))
            }, {
              default: _withCtx(() => [_createTextVNode("图片指引")]),
              _: 1
            })])];
          }),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});